export default "__VITE_ASSET__c7cacfd7__"